import * as React from 'react';
import { connect } from 'react-redux';
import AppActions from '../../app/app_actions';
import { Utils, isAuth, NumberFormatter, domain, domainVal, i18n, DateFormatter } from 'arm-common';
import * as agui from 'arm-gui/dist/controls';

import { AppConstants } from '../../constants/AppConstants';
// import MicroCategoriaActions from '../gruppoProdotto/gruppoProdotto_actions'
import MicroCategorieActions from '../microCategorie/microCaterogieActions'
import ProdottoActions from '../prodotto/prodotto_actions'
import FamiglieProdottoActions from './famiglieProdottoActions'
import FamiglieProdottoDetails from './famiglieProdottoDetails.jsx'
import ConfirmModalDeleteV4 from '../shared/confirmModalDeleteV4.jsx'
import CategorieProdottoAction from '../categorieProdotto/categorieProdottoActions'
import PopupCrezioneFP from './popUpCreazioneFP.jsx';
import CategorieProdottoDetails from '../categorieProdotto/categoriaProdottoDetails.jsx'
import ApplicationData from '../../app/aApplicationData'

class FamiglieProdotto extends React.Component {
    constructor(props) {
        super(props);
        this.componentName = '[FamiglieProdotto.jsx]';
        this.ambitoDetails = this.ambitoDetails.bind(this);
        this.dettaglioMicroCategoria = this.dettaglioMicroCategoria.bind(this);
        this.famigliaProdottoDetails = this.famigliaProdottoDetails.bind(this);
        this.categoriaProdottoDetails = this.categoriaProdottoDetails.bind(this);
        this.creaNuovo = this.creaNuovo.bind(this);
        this.showConfirm = this.showConfirm.bind(this);
        this.inputChangeHandler = this.inputChangeHandler.bind(this);
        this.salvaApDom = this.salvaApDom.bind(this);
        this.aggiornaAlbero = this.aggiornaAlbero.bind(this);
        this.getMicroCategoriaDetails = this.getMicroCategoriaDetails.bind(this);
        this.getTipoDaCreare = this.getTipoDaCreare.bind(this);
        this.creaNuovoAmbito = this.creaNuovoAmbito.bind(this);
        this.aggiornaDomini = this.aggiornaDomini.bind(this);
        this.inizializzaNuovoProdottoDaMicroCategoria = this.inizializzaNuovoProdottoDaMicroCategoria.bind(this);

        // nuovi
        this.inputChangeHandlerFamiglia = this.inputChangeHandlerFamiglia.bind(this);
        this.salvaFamigliaProdotto = this.salvaFamigliaProdotto.bind(this);
        this.showConfirmDelete = this.showConfirmDelete.bind(this);
        this.deleteFamigliaProdotto = this.deleteFamigliaProdotto.bind(this);
        this.modificaFamigliaProdotto = this.modificaFamigliaProdotto.bind(this);
        this.creaNuovaCategoriaProdotto = this.creaNuovaCategoriaProdotto.bind(this);
        this.inputChangeHandlerCategoria = this.inputChangeHandlerCategoria.bind(this);
        this.deleteCategoriaProdotto = this.deleteCategoriaProdotto.bind(this);
        this.salvaCategoria = this.salvaCategoria.bind(this);
        this.showConfirmModifica = this.showConfirmModifica.bind(this);
        this.modificaCategoriaProdotto = this.modificaCategoriaProdotto.bind(this);
        this.annullaModificaButton = this.annullaModificaButton.bind(this);



        this.state = {
            oggetoDaVisualizzare: null,
            tipoVisualizzato: null,
            tabAperte: new Map(),
            validation: new Map(),
            apDom: {},
            showConfirm: false,
            showConfirmDelete: false,
            modificaFamigliaProdotto: false,
            showConfirmModifica: false,
        }
    }

    componentDidMount() {
        console.log(this.componentName + ' componentDidMount');

        this.props.getListFamiglie();
        this.props.getListaCategorie();
        this.props.getListaMicroCategorie();


    }

    componentDidUpdate() {

        $(document).ready(function () {
            $('#target1').on('hidden.bs.collapse', function () {
                console.log('triggered');
                $('#target2').collapse('hide');
            });
        });

    }


    componentWillReceiveProps(nextProps) {
        console.log(this.componentName + ' componentWillReceiveProps');

        if (nextProps.rows !== this.props.rows) {
            console.log("\t rows: " + (nextProps.rows !== null ? nextProps.rows.length : "NULL"));

            if (nextProps.rows === null) {
                $(this.refs.MyTable).bootstrapTable('removeAll');
            } else {
                $(this.refs.MyTable).bootstrapTable('load', nextProps.rows);
            }
        }
    }

    annullaModificaButton() {
        console.log(this.componentName + ' annullaModificaButton');
        this.showConfirmModifica();
        if (this.state.tipoVisualizzato === "Categoria Prodotto") {
            let id = this.props.categoriaProdotto.id;
            if (id !== undefined && id !== null) {
                this.props.getCategoriaProdottoDetails(id).then(
                    resolve => {
                        this.forceUpdate();
                    }, reject => {
                    }
                )
            }

        } else if (this.state.tipoVisualizzato === "Famiglia Prodotto") {
            let id = this.props.famigliaProdotto.id;
            if (id !== undefined && id !== null) {
                this.props.getFamigliaProdottoDetails(id).then(
                    resolve => {
                        this.forceUpdate();
                    }, reject => {
                    }
                )
            }
        }
    }

    dettaglioMicroCategoria() {
        let idMicroCategoria = this.state.oggetoDaVisualizzare.id;
        console.log(this.componentName + "dettaglioMicroCategoria [idMicroCategoria] " + idMicroCategoria);
        this.props.history.push({ pathname: '/microCategorie/details', state: { id: idMicroCategoria } });
    }

    modificaFamigliaProdotto() {

        console.log(this.componentName + ' modificaFamigliaProdotto');

        this.showConfirmModifica();
    }

    modificaCategoriaProdotto() {

        console.log(this.componentName + ' modificaCategoriaProdotto');

        this.showConfirmModifica();
    }

    showConfirmDelete() {
        console.log(this.componentName + ' showConfirmDelete');

        this.setState({ showConfirmDelete: !this.state.showConfirmDelete })

    }

    deleteFamigliaProdotto() {

        console.log(this.componentName + ' deleteFamigliaProdotto');

        this.showConfirmDelete();
        this.props.deleteFamigliaProdotto(this.props.famigliaProdotto.id).then(
            resolve => {
                this.props.getListFamiglie();
            }
        );
        ;
    }

    deleteCategoriaProdotto() {

        console.log(this.componentName + ' deleteCategoriaProdotto');

        this.showConfirmDelete();
        this.props.deleteCategoriaProdotto(this.props.categoriaProdotto.id).then(
            resolve => {
                this.props.getListaCategorie();
            }
        );
        ;
    }

    inputChangeHandlerFamiglia(e) {

        let id = e.target.id;
        let value = e.target.value;
        console.log(this.componentName + ' inputChangeHandlerFamiglia: [id]: ' + id + " [value]: " + value);

        this.props.inputChangeHandlerFamiglia(id, value);

    }

    inputChangeHandlerCategoria(e) {

        let id = e.target.id;
        let value = e.target.value;
        console.log(this.componentName + ' inputChangeHandlerCategoria: [id]: ' + id + " [value]: " + value);

        this.props.inputChangeHandlerCategoria(id, value);

    }

    creaNuovaCategoriaProdotto() {
        console.log(this.componentName + ' creaNuovaCategoriaProdotto');

        this.props.inizializzaNuovaCategoria().then(
            resolve => {
                this.showConfirm();
            }
        )


    }

    salvaApDom() {

        if (!this.validateForm()) {
            return false;
        }
        console.log(this.componentName + ' salvaApDom');
        this.showConfirm();

        let tipoDaCreate = this.getTipoDaCreare();
        this.props.salvaApDom(this.state.apDom, tipoDaCreate).then(
            resolve => {
                this.props.reLoadDomini().then(
                    resolve => {
                        // non la carica immediatamente se non la forciamo. 
                        this.forceUpdate();
                    }
                )
            }
        );
    }


    aggiornaAlbero(e) {

        let id = e.currentTarget.id;
        console.log(this.componentName + 'aggiornaAlbero id:' + id);

        let tabAperte = this.state.tabAperte;
        if (tabAperte.get(id) !== null && tabAperte.get(id) !== undefined && tabAperte.get(id) !== "close") {
            tabAperte.set(id, "close")
        } else {
            tabAperte.set(id, "open")
        }

        this.setState({
            tabAperte: tabAperte
        });

    }

    inputChangeHandler(e) {

        let id = e.target.id;
        let value = e.target.value;
        console.log(this.componentName + ' inputChangeHandler [id]: ' + id + '[value]: ' + value);

        if (this.state.validation.has(id)) {
            this.state.validation.delete(id);
        }
        if (id === "valCampo" && value.includes(" ")) {
            this.state.validation.set(id, i18n('ARM_CORE_PRODUCT.SHARED.SPAZI_NON_ACCETATI', 'Spazi non sono permessi per questo campo'));
            this.setState({
                validation: this.state.validation,
                apDom: this.state.apDom
            });
            return;
        }
        let apDom = this.state.apDom;
        apDom[id] = value;

        this.setState({
            apDom: apDom,
            validation: this.state.validation
        });

    }

    creaNuovo() {
        console.log(this.componentName + ' creaNuovo');
        let state = this.state;
        if (state.tipoVisualizzato === "Categoria Prodotto") {
            this.inizializzaNuovoMicroCategoriaDaCategoria();
            // this.props.history.push('/gruppoProdotto/create');
            return;
        }

        state.apDom.codCampo = this.state.oggetoDaVisualizzare.id.codCampo;
        state.validation = new Map();

        switch (state.tipoVisualizzato) {
            case "Ambito":
                state.apDom = {
                    // codCampo: 'AI_GRUPPO_RAMO',
                    // info: "AMBITO:" + this.state.oggetoDaVisualizzare.id.valCampo + ";"
                }

                this.props.inizializzaNuovaFamiglia();
                // imposta l'ambito
                // this.props.inputChangeHandlerFamiglia("codAmbito", this.state.oggetoDaVisualizzare.id.valCampo);
                break;
            case "Famiglia Prodotto":
                this.props.inizializzaNuovaCategoria();
                break;
            default:
                state.apDom.codCampo = 'AI_AMBITO_RAMO'
                break;
        }
        this.setState(state);
        this.showConfirm();

    }

    creaNuovoAmbito() {

        this.state.apDom = {
            codCampo: 'AI_AMBITO_RAMO'
        }
        this.setState(this.state);
        this.showConfirm();
    }

    aggiornaDomini() {
        this.props.reLoadDomini();
    }

    showConfirm() {
        console.log(this.componentName + ' showConfirm');

        this.setState({ showConfirm: !this.state.showConfirm });
    }

    showConfirmModifica() {
        console.log(this.componentName + ' showConfirmModifica');

        this.setState({ showConfirmModifica: !this.state.showConfirmModifica });
    }


    ambitoDetails(e) {

        let id = e.currentTarget.id;
        console.log(this.componentName + 'ambitoDetails id:' + id);

        let ambito = ApplicationData.domainVal("AI_AMBITO_RAMO", id, id);

        let tabAperte = this.state.tabAperte;
        if (tabAperte.get(id) !== null && tabAperte.get(id) !== undefined && tabAperte.get(id) !== "close") {
            tabAperte.set(id, "close")
            this.closeAmbitoChildren(id);
        } else {
            tabAperte.set(id, "open")
        }

        this.setState({
            oggetoDaVisualizzare: ambito,
            tipoVisualizzato: "Ambito",
            tabAperte: tabAperte
        });

    }

    closeAmbitoChildren(id) {
        let element = "ambito" + id
        $('ul[id*="' + element + '"]').collapse('hide');

        let tabAperte = this.state.tabAperte;

        let famiglieProdotto = this.props.famiglieProdotto;
        famiglieProdotto.forEach(famigliaProdotto => {


            if (famigliaProdotto.codAmbito === id) {
                this.closeFamigliaProdottoChildren(famigliaProdotto.id);
                tabAperte.set("famiglia" + famigliaProdotto.id, "close");


            };

        });
    }

    closeFamigliaProdottoChildren(id) {
        let element = "categoria" + id
        $('ul[id*="' + element + '"]').collapse('hide');

        let tabAperte = this.state.tabAperte;

        let categorie = this.props.categorieProdotto;
        categorie.forEach(categoria => {


            if (categoria.idFamigliaProdotto === parseInt(id)) {
                tabAperte.set("categoria" + categoria.id, "close");
                // this.closeFamigliaProdottoChildren(categoria.id);
                // this.closeCategoriaChildren(id);
            };

        });
    }

    closeCategoriaChildren(id) {
        let element = "categoria" + id
        $('ul[id*="' + element + '"]').collapse('hide');
        // $('ul[id^="' + element + '"]').collapse('hide');

        let tabAperte = this.state.tabAperte;

        let microCategorie = this.props.listMC;
        microCategorie.forEach(microCategoria => {

            if (microCategoria.idCategoriaProdotto === parseInt(id)) {
                tabAperte.set("microCategoria" + microCategoria.id, "close");
            }

            // if (categoria.info && categoria.info.split('GRUPPO_RAMO:')
            //     && categoria.info.split('GRUPPO_RAMO:')[1]
            //     && categoria.info.split('GRUPPO_RAMO:')[1].split(';')[0]
            //     && categoria.info.split('GRUPPO_RAMO:')[1].split(';')[0] === id) {
            //     tabAperte.set(categoria.id, "close");
            //     // this.closeFamigliaProdottoChildren(categoria.id);
            // };

        });
    }


    famigliaProdottoDetails(e) {

        let id = e.currentTarget.id;
        console.log(this.componentName + 'famigliaProdottoDetails id:' + id);

        this.props.getFamigliaProdottoDetails(id).then(
            resolve => {

            }
        )
        let tabAperte = this.state.tabAperte;
        if (tabAperte.get("famiglia" + id) !== null && tabAperte.get("famiglia" + id) !== undefined && tabAperte.get("famiglia" + id) !== "close") {
            this.closeFamigliaProdottoChildren(id);
            tabAperte.set("famiglia" + id, "close")
        } else {
            tabAperte.set("famiglia" + id, "open")
        }


        // ??

        this.setState({
            oggetoDaVisualizzare: this.props.famigliaProdotto,
            tipoVisualizzato: "Famiglia Prodotto",
            tabAperte: tabAperte
        });

    }

    categoriaProdottoDetails(e) {

        let id = e.currentTarget.id;
        console.log(this.componentName + 'categoriaProdottoDetails id:' + id);

        this.props.getCategoriaProdottoDetails(id).then(
            resolve => {

            }
        )
        let tabAperte = this.state.tabAperte;
        if (tabAperte.get("categoria" + id) !== null && tabAperte.get("categoria" + id) !== undefined && tabAperte.get("categoria" + id) !== "close") {
            this.closeCategoriaChildren(id);
            tabAperte.set("categoria" + id, "close");
        } else {
            tabAperte.set("categoria" + id, "open")
        }

        this.setState({
            oggetoDaVisualizzare: this.props.categoriaProdotto,
            tipoVisualizzato: "Categoria Prodotto",
            tabAperte: tabAperte
        });

    }

    getMicroCategoriaDetails(e) {


        let id = e.currentTarget.id;
        console.log(this.componentName + 'getMicroCategoriaDetails id:' + id);

        let microCategoria = this.props.listMC.find(gp => gp.id === parseInt(id));


        this.setState({
            oggetoDaVisualizzare: microCategoria,
            tipoVisualizzato: "Micro Categoria",
        });

    }

    getTipoDaCreare() {

        console.log(this.componentName + 'getTipoDaCreare');
        switch (this.state.tipoVisualizzato) {
            case "Ambito":
                return "Famiglia Prodotto"
            case "Famiglia Prodotto":
                return "Categoria"
            case "Categoria Prodotto":
                return "Micro-Categoria"
            default:
                return "Ambito"
        }
    }


    dateFormatter(value, row, index) {
        return DateFormatter.dataFormatter(value);
    }
    dateFormatterShort(value, row, index) {
        return DateFormatter.dataFormatterShort(value);
    }

    validateForm() {
        console.log(this.componentName + 'validateForm');
        let validation = new Map();
        let required = ['valCampo', 'desDom'];
        for (let i = 0; i < required.length; i++) {
            if (this.state.apDom[required[i]] === undefined || this.state.apDom[required[i]] === null || this.state.apDom[required[i]] === '') {
                validation.set(required[i], i18n('ARM_CORE_PRODUCT.SHARED.VALORE_OBBLIGATORIO', 'valore obbligatorio'));
            }
        }
        this.setState({ validation: validation });
        if (validation.size === 0) {
            return true;
        }
        return false;
    }

    inizializzaNuovoProdottoDaMicroCategoria() {
        console.log(this.componentName + 'inizializzaNuovoProdottoDaMicroCategoria');

        let idMicroCategoria = this.state.oggetoDaVisualizzare.id;

        this.props.inizializzaNuovoProdottoDaMicroCategoria(idMicroCategoria).then(

            resolve => {
                this.props.history.push('/prodotto/create');
            },

            reject => {

                console.log(this.componentName + 'inizializzaNuovoProdottoDaMicroCategoria KO');
            }
        );


    }

    inizializzaNuovoMicroCategoriaDaCategoria() {
        console.log(this.componentName + 'inizializzaNuovoMicroCategoriaDaCategoria');

        let idCategoria = this.props.categoriaProdotto.id;

        this.props.inizializzaNuovoMicroCategoriaDaCategoria(idCategoria).then(

            resolve => {
                this.props.impostaCampiSuperioriMicroCategoria("idCategoriaProdotto").then(
                    resolve => {
                        // la imposto come famigliaProdottoOrigine per non riInzializzare il oggetto. 
                        this.props.history.push({
                            pathname: '/microCategorie/create', state: {
                                famigliaProdottoOrigine: true
                            }
                        })
                    },
                    reject => {
                        console.log(this.componentName + 'impostaCampiSuperioriMicroCategoria KO');
                    }
                )

            },

            reject => {

                console.log(this.componentName + 'inizializzaNuovoMicroCategoriaDaCategoria KO');
            }
        );


    }

    salvaFamigliaProdotto() {
        console.log(this.componentName + 'salvaFamigliaProdotto()');
        let ambito;
        if (this.props.famigliaProdotto.codAmbito !== undefined
            && this.props.famigliaProdotto.codAmbito !== null
            && this.props.famigliaProdotto.codAmbito !== "") {
            ambito = this.props.famigliaProdotto.codAmbito;
        } else {
            ambito = this.state.oggetoDaVisualizzare.id.valCampo;
        }
        if (this.state.showConfirmModifica) {
            this.showConfirmModifica()
        } else {
            this.showConfirm();
        }
        this.props.salvaFamigliaProdotto(ambito).then(
            resolve => {
                this.props.getListFamiglie();
            }
        );
    }

    salvaCategoria() {
        console.log(this.componentName + 'salvaCategoria()');
        let idFamigliaProdotto;
        if (this.props.categoriaProdotto.idFamigliaProdotto !== undefined
            && this.props.categoriaProdotto.idFamigliaProdotto !== null
            && this.props.categoriaProdotto.idFamigliaProdotto !== "") {
            idFamigliaProdotto = this.props.categoriaProdotto.idFamigliaProdotto;

        } else {
            idFamigliaProdotto = this.props.famigliaProdotto.id;
        }
        if (this.state.showConfirmModifica) {
            this.showConfirmModifica()
        } else {
            this.showConfirm();
        }
        this.props.salvaCategoria(idFamigliaProdotto).then(
            resolve => {
                this.props.getListaCategorie();
            }
        );
    }

    render() {
        console.log(this.componentName + ' render');
        return (
            <div>
                <div className="card">
                    <div className="card-header">
                        <agui.aButton bs="primary" className="float-right " icon="fas fa-sync-alt" onClick={this.aggiornaDomini}>{i18n('ARM_CORE_PRODUCT.PRODOTTO.AGGIORNA', 'Aggiorna')}</agui.aButton>
                        {isAuth('NEW_AMBITO') && isAuth('V2.ADMIN.PRODUCT.VIEW.CREATE') &&
                            <agui.aButton bs="primary" className="float-right mr-2" icon="fas fa-plus" onClick={this.creaNuovoAmbito}>Ambito</agui.aButton>}
                        <h3>{i18n('ARM_CORE_PRODUCT.PRODOTTO.CATALOGO_PRODOTTI', 'Catalogo Prodotti')}</h3>
                    </div>
                    <div className="row">
                        <div className=" row card-body" style={{ marginBottom: "100px" }}>
                            <div className=" col-6 treeview-animated w-20 ">
                                <ul className="treeview-animated-list mb-3">
                                    {domain("AI_AMBITO_RAMO") && domain("AI_AMBITO_RAMO").map(

                                        (ambito, index) =>
                                            ambito.valCampo &&
                                            <li key={"ambito" + index} id={"ambito" + index} className="treeview-animated-items">
                                                <a className="treeview-animated-items-header" id={ambito.valCampo} href={"#ambito" + ambito.valCampo + "gruppi" + ambito.valCampo} onClick={this.ambitoDetails} data-toggle="collapse" data-parent={"#ambito" + index}>
                                                    <i className={this.state.tabAperte.get(ambito.valCampo) && this.state.tabAperte.get(ambito.valCampo) === "open" ?
                                                        "fas fa-minus-circle mr-1" : "fas fa-plus-circle mr-1"}></i>
                                                    <span>{ambito.desDom}</span>
                                                </a>
                                                {/* <ul id={"ambito" + ambito.valCampo} className="nested collapse">
                                            <li className="treeview-animated-items"> */}
                                                {/* <a className="treeview-animated-items-header" href={"#ambito" + ambito.valCampo + "gruppi" + ambito.valCampo} id={"listaFamiglie" + ambito.valCampo} onClick={this.aggiornaAlbero} data-toggle="collapse">
                                                    <i className={this.state.tabAperte.get("listaFamiglie" + ambito.valCampo) && this.state.tabAperte.get("listaFamiglie" + ambito.valCampo) === "open" ?
                                                        "fas fa-minus-circle mr-1" : "fas fa-plus-circle mr-1"}></i>
                                                    Famiglie Prodotto </a> */}
                                                <ul id={"ambito" + ambito.valCampo + "gruppi" + ambito.valCampo} className="nested collapse">
                                                    {this.props.famiglieProdotto && this.props.famiglieProdotto.map(
                                                        (famigliaProdotto, indexFamiglia) =>
                                                            // famigliaProdotto.info && famigliaProdotto.info.split('AMBITO:')
                                                            //     && famigliaProdotto.info.split('AMBITO:')[1]
                                                            //     && famigliaProdotto.info.split('AMBITO:')[1].split(';')[0]
                                                            //     && famigliaProdotto.info.split('AMBITO:')[1].split(';')[0] === ambito.valCampo ?

                                                            famigliaProdotto.codAmbito === ambito.valCampo ?

                                                                <li key={"famigliaProdotto" + indexFamiglia} className="treeview-animated-items">
                                                                    <a className="treeview-animated-items-header" id={famigliaProdotto.id} onClick={this.famigliaProdottoDetails} href={"#ambito" + ambito.valCampo + "categoria" + famigliaProdotto.id} data-toggle="collapse">
                                                                        <i className={this.state.tabAperte.get("famiglia" + famigliaProdotto.id + "") && this.state.tabAperte.get("famiglia" + famigliaProdotto.id + "") === "open" ?
                                                                            "fas fa-minus-circle mr-1" : "fas fa-plus-circle mr-1"}></i>
                                                                        <span>{famigliaProdotto.nome}</span>
                                                                    </a>

                                                                    {/* <ul id={"famigliaProdotto" + famigliaProdotto.id} className="nested collapse"> */}
                                                                    {/* <li className="treeview-animated-items"> */}
                                                                    {/* <a className="treeview-animated-items-header" href={"#categoria" + famigliaProdotto.id} id={"categorie" + famigliaProdotto.id} onClick={this.aggiornaAlbero} data-toggle="collapse" >
                                                                                <i className={this.state.tabAperte.get("categorie" + famigliaProdotto.id) && this.state.tabAperte.get("categorie" + famigliaProdotto.id) === "open" ?
                                                                                    "fas fa-minus-circle mr-1" : "fas fa-plus-circle mr-1"}></i>  {i18n('ARM_CORE_PRODUCT.SHARED.CATEGORIE_PRODOTTO', 'Categorie Prodotto')}</a> */}
                                                                    <ul id={"ambito" + ambito.valCampo + "categoria" + famigliaProdotto.id} className="nested collapse">
                                                                        {/* {domain("AI_RAMO_POLIZZA") && domain("AI_RAMO_POLIZZA").map( */}
                                                                        {this.props.categorieProdotto && this.props.categorieProdotto.map(
                                                                            (categoria, indexCategoria) =>
                                                                                categoria.idFamigliaProdotto && categoria.idFamigliaProdotto === famigliaProdotto.id ?

                                                                                    <li key={"categoria" + indexCategoria} className="treeview-animated-items">
                                                                                        <a className="treeview-animated-items-header" id={categoria.id} onClick={this.categoriaProdottoDetails}
                                                                                            href={"#ambito" + ambito.valCampo + "categoria" + famigliaProdotto.id + "microCategorieList" + categoria.id} data-toggle="collapse">
                                                                                            <i className={this.state.tabAperte.get("categoria" + categoria.id) && this.state.tabAperte.get("categoria" + categoria.id) === "open" ?
                                                                                                "fas fa-minus-circle mr-1" : "fas fa-plus-circle mr-1"}></i>
                                                                                            <span>{categoria.nome}</span>
                                                                                        </a>

                                                                                        {/* <ul id={"categoria" + categoria.id} className="nested collapse">
                                                                                    <li className="treeview-animated-items">
                                                                                        <a className="treeview-animated-items-header" href={"#microCategorieList" + categoria.id} onClick={this.aggiornaAlbero} id={"microCategorie" + categoria.id} data-toggle="collapse">
                                                                                            <i className={this.state.tabAperte.get("microCategorie" + categoria.id) && this.state.tabAperte.get("microCategorie" + categoria.id) === "open" ?
                                                                                                "fas fa-minus-circle mr-1" : "fas fa-plus-circle mr-1"}></i> {i18n('ARM_CORE_PRODUCT.SHARED.MICRO_CATEGORIE', 'Micro-categorie')} </a> */}
                                                                                        <ul id={"ambito" + ambito.valCampo + "categoria" + famigliaProdotto.id + "microCategorieList" + categoria.id} className="nested collapse">
                                                                                            {this.props.listMC && this.props.listMC.map(
                                                                                                (microCategoria, indexCategoria) =>

                                                                                                    microCategoria.idCategoriaProdotto && microCategoria.idCategoriaProdotto === categoria.id ?
                                                                                                        <li key={"microCat" + indexCategoria} className="treeview-animated-items">
                                                                                                            <a className="treeview-animated-items-header" href={"#microCategoria" + microCategoria.id} id={microCategoria.id} onClick={this.getMicroCategoriaDetails} data-toggle="collapse">
                                                                                                                {/* <i className="fas fa-plus-circle mr-1"></i> */}
                                                                                                                <span>{microCategoria.nome}</span>
                                                                                                            </a>
                                                                                                        </li> : null
                                                                                            )}
                                                                                        </ul>
                                                                                        {/* </li> */}
                                                                                        {/* </li> */}
                                                                                        {/* </ul> */}
                                                                                    </li> : null
                                                                        )}
                                                                    </ul>
                                                                    {/* </li> */}
                                                                    {/* </li> */}
                                                                    {/* </ul> */}
                                                                </li> : null
                                                    )}
                                                </ul>
                                                {/* </li>

                                        </ul> */}
                                            </li>


                                    )}

                                </ul>


                            </div>

                            <div className="col-6 " style={{ minHeight: 200, width: 100 }}>
                                {this.state.oggetoDaVisualizzare ?
                                    this.state.tipoVisualizzato === "Famiglia Prodotto" ?
                                        <div className="card">
                                            <div className="card-header">
                                                {isAuth('V2.ADMIN.PRODUCT.VIEW.CREATE') &&
                                                    <agui.aButton bs="primary" className="float-right" icon="fas fa-plus" onClick={this.creaNuovaCategoriaProdotto}>{this.getTipoDaCreare()}</agui.aButton>
                                                }
                                                <h5> {i18n('ARM_CORE_PRODUCT.SHARED.DETTAGLIO_DI', 'Dettaglio di')} {this.state.tipoVisualizzato}</h5>
                                            </div>
                                            <FamiglieProdottoDetails famigliaProdotto={this.props.famigliaProdotto}
                                                // inputChangeHandlerFamiglia={this.inputChangeHandlerFamiglia}
                                                showConfirmPanelDelete={this.showConfirmDelete}
                                                modificaFamigliaProdotto={this.modificaFamigliaProdotto}
                                                validation={this.state.validation} modifica={this.state.modificaFamigliaProdotto} />
                                        </div>
                                        : this.state.tipoVisualizzato === "Categoria Prodotto" ?
                                            <div className="card">
                                                <div className="card-header">
                                                    {isAuth('V2.ADMIN.PRODUCT.VIEW.CREATE') &&
                                                        <agui.aButton bs="primary" className="float-right" icon="fas fa-plus" onClick={this.creaNuovo}>{this.getTipoDaCreare()}</agui.aButton>
                                                    }
                                                    <h5> {i18n('ARM_CORE_PRODUCT.SHARED.DETTAGLIO_DI', 'Dettaglio di')} {this.state.tipoVisualizzato}</h5>
                                                </div>
                                                <CategorieProdottoDetails categoriaProdotto={this.props.categoriaProdotto}
                                                    // inputChangeHandlerFamiglia={this.inputChangeHandlerFamiglia}
                                                    showConfirmPanelDelete={this.showConfirmDelete}
                                                    modificaCategoriaProdotto={this.modificaCategoriaProdotto}
                                                />
                                            </div>
                                            :

                                            this.state.tipoVisualizzato === "Micro Categoria" ?
                                                <div className="card">
                                                    <div className="card-header">
                                                        {isAuth('V2.ADMIN.PRODUCT.VIEW.CREATE') &&
                                                            <agui.aButton bs="primary" className="float-right" icon="fas fa-plus" onClick={this.inizializzaNuovoProdottoDaMicroCategoria}>{i18n('ARM_CORE_PRODUCT.SHARED.PRODOTTO', 'Prodotto')}</agui.aButton>
                                                        }
                                                        <h5> {i18n('ARM_CORE_PRODUCT.SHARED.DETTAGLIO_DI', 'Dettaglio di')} {this.state.tipoVisualizzato}</h5>
                                                    </div>
                                                    <div className="card-body">
                                                        <div className="row">
                                                            <dt className="col-sm-4 col-6">{i18n('ARM_CORE_PRODUCT.MANAGE.Codice', 'Codice')}</dt>
                                                            <dd className="col-sm-8 col-6">{this.state.oggetoDaVisualizzare.id}</dd>
                                                        </div>
                                                        <div className="row">
                                                            <dt className="col-sm-4 col-6 ">{i18n('ARM_CORE_PRODUCT.SHARED.NOME', 'Nome')}</dt>
                                                            <dd className="col-sm-8 col-6">{this.state.oggetoDaVisualizzare.nome}</dd>
                                                        </div>
                                                        <div className="row">
                                                            <dt className="col-sm-4 col-6 ">{i18n('ARM_CORE_PRODUCT.SHARED.DESCRIZIONE', 'Descrizione')}</dt>
                                                            <dd className="col-sm-8 col-6">{this.state.oggetoDaVisualizzare.descrizione}</dd>
                                                        </div>

                                                    </div>


                                                    <agui.aButton bs="primary" onClick={this.dettaglioMicroCategoria}>{i18n('ARM_CORE_PRODUCT.SHARED.DETTAGLIO', 'Dettaglio')}</agui.aButton>

                                                </div>
                                                :

                                                <div className="card">
                                                    <div className="card-header">
                                                        {isAuth('V2.ADMIN.PRODUCT.VIEW.CREATE') &&
                                                            <agui.aButton bs="primary" className="float-right" icon="fas fa-plus" onClick={this.creaNuovo}>{this.getTipoDaCreare()}</agui.aButton>
                                                        }
                                                        <h5> {i18n('ARM_CORE_PRODUCT.SHARED.DETTAGLIO_DI', 'Dettaglio di')} {this.state.tipoVisualizzato}</h5>
                                                    </div>
                                                    <div className="card-body">
                                                        <div className="row">
                                                            <dt className="col-sm-4 col-6">{i18n('ARM_CORE_PRODUCT.MANAGE.Codice', 'Codice')}</dt>
                                                            <dd className="col-sm-8 col-6">{this.state.oggetoDaVisualizzare.valCampo}</dd>
                                                        </div>
                                                        <div className="row">
                                                            <dt className="col-sm-4 col-6 ">{i18n('ARM_CORE_PRODUCT.SHARED.DESCRIZIONE', 'Descrizione')}</dt>
                                                            <dd className="col-sm-8 col-6">{this.state.oggetoDaVisualizzare.desDom}</dd>
                                                        </div>
                                                        <div className="row">
                                                            <dt className="col-sm-4 col-6 ">{i18n('ARM_CORE_PRODUCT.SHARED.INFO', 'Info')}</dt>
                                                            <dd className="col-sm-8 col-6">{this.state.oggetoDaVisualizzare.info}</dd>
                                                        </div>

                                                    </div>

                                                </div>
                                    : null


                                }
                            </div>
                        </div>
                    </div>
                </div>
                {(this.state.apDom.codCampo && this.state.apDom.codCampo !== 'AI_AMBITO_RAMO') ?

                    <PopupCrezioneFP tipoDaCreare="Ambito" showConfirm={this.state.showConfirm
                    } inputChangeHandler={this.inputChangeHandler} oggettoDaCreare={this.state.apDom}
                        annullaButton={this.showConfirm}
                        salvaOggetto={this.salvaApDom} showConfirmPanel={this.showConfirm}
                    />
                    :
                    this.state.showConfirmModifica && this.state.showConfirmModifica === true ?
                        this.state.tipoVisualizzato && this.state.tipoVisualizzato === "Famiglia Prodotto" ?
                            <PopupCrezioneFP tipoDaCreare="Famiglia Prodotto" showConfirm={this.state.showConfirmModifica
                            } inputChangeHandler={this.inputChangeHandlerFamiglia} oggettoDaCreare={this.props.famigliaProdotto}
                                tipoVisualizzato={this.state.tipoVisualizzato} tipoDescrizione={this.state.oggetoDaVisualizzare.desDom}
                                showConfirmPanel={this.showConfirmModifica}
                                annullaButton={this.annullaModificaButton}
                                modifica={true}
                                salvaOggetto={this.salvaFamigliaProdotto}
                            />
                            :
                            this.state.tipoVisualizzato && this.state.tipoVisualizzato === "Categoria Prodotto" ?
                                <PopupCrezioneFP
                                    tipoDaCreare="Categoria" showConfirm={this.state.showConfirmModifica
                                    } inputChangeHandler={this.inputChangeHandlerCategoria} oggettoDaCreare={this.props.categoriaProdotto}
                                    salvaOggetto={this.salvaCategoria} showConfirmPanel={this.showConfirmModifica}
                                    modifica={true}
                                    annullaButton={this.annullaModificaButton}
                                    tipoVisualizzato={this.state.tipoVisualizzato} tipoDescrizione={this.props.famigliaProdotto.nome} />
                                :
                                null
                        :
                        this.getTipoDaCreare() && this.getTipoDaCreare() === "Famiglia Prodotto" ?
                            <PopupCrezioneFP tipoDaCreare="Famiglia Prodotto" showConfirm={this.state.showConfirm
                            } inputChangeHandler={this.inputChangeHandlerFamiglia} oggettoDaCreare={this.props.famigliaProdotto}
                                tipoVisualizzato={this.state.tipoVisualizzato} tipoDescrizione={this.state.oggetoDaVisualizzare.desDom}
                                showConfirmPanel={this.showConfirm}
                                annullaButton={this.showConfirm}
                                salvaOggetto={this.salvaFamigliaProdotto}
                            />

                            : this.getTipoDaCreare() && this.getTipoDaCreare() === "Categoria" ?
                                <PopupCrezioneFP
                                    tipoDaCreare="Categoria" showConfirm={this.state.showConfirm
                                    } inputChangeHandler={this.inputChangeHandlerCategoria} oggettoDaCreare={this.props.categoriaProdotto}
                                    salvaOggetto={this.salvaCategoria} showConfirmPanel={this.showConfirm}
                                    annullaButton={this.showConfirm}
                                    tipoVisualizzato={this.state.tipoVisualizzato} tipoDescrizione={this.props.famigliaProdotto.nome} />
                                :
                                this.state.tipoVisualizzato && this.state.tipoVisualizzato === "Categoria" ?
                                    <PopupCrezioneFP
                                        tipoDaCreare="Categoria" showConfirm={this.state.showConfirmModifica
                                        } inputChangeHandler={this.inputChangeHandlerCategoria} oggettoDaCreare={this.props.categoriaProdotto}
                                        salvaOggetto={this.salvaCategoria} showConfirmPanel={this.showConfirmModifica}
                                        modifica={true} annullaButton={this.showConfirm}
                                        tipoVisualizzato={this.state.tipoVisualizzato} tipoDescrizione={this.props.famigliaProdotto.nome} />
                                    : null
                }




                <ConfirmModalDeleteV4
                    show={this.state.showConfirmDelete}
                    deleteOnClick={this.state.tipoVisualizzato === "Famiglia Prodotto" ? this.deleteFamigliaProdotto : this.deleteCategoriaProdotto}
                    onClose={this.showConfirmDelete} />
            </div>
        );
    }
};

function mapDispatchToProps(dispatch) {
    return {
        getListaMicroCategorie() {
            return dispatch(MicroCategorieActions.getListMicroCategorie())
        },
        salvaApDom(apDom, tipoDaCreare) {
            return dispatch(MicroCategorieActions.salvaApDom(apDom, tipoDaCreare))
        },
        reLoadDomini() {
            return dispatch(AppActions.reLoadDomini())
        },
        inizializzaNuovoProdottoDaMicroCategoria(idMicroCategoria) {
            return dispatch(ProdottoActions.inizializzaNuovoProdottoDaMicroCategoria(idMicroCategoria))
        },
        inizializzaNuovoMicroCategoriaDaCategoria(idCategoria) {
            return dispatch(MicroCategorieActions.inizializzaNuovoMicroCategoriaDaCategoria(idCategoria))
        },
        impostaCampiSuperioriMicroCategoria(campo) {
            return dispatch(MicroCategorieActions.impostaCampiSuperioriMicroCategorie(campo));
        },
        getListFamiglie() {
            return dispatch(FamiglieProdottoActions.getListFamiglie());
        },
        inputChangeHandlerFamiglia(id, value) {
            return dispatch(FamiglieProdottoActions.handleChange(id, value))
        },
        salvaFamigliaProdotto(ambito) {
            return dispatch(FamiglieProdottoActions.salvaFamiglia(ambito))
        },
        getFamigliaProdottoDetails(id) {
            return dispatch(FamiglieProdottoActions.getFamigliaDetails(id))
        },
        deleteFamigliaProdotto(id) {
            return dispatch(FamiglieProdottoActions.deleteFamiglia(id))
        },
        inizializzaNuovaFamiglia() {
            return dispatch(FamiglieProdottoActions.inizializzaNuovaFamiglia())
        },
        getListaCategorie() {
            return dispatch(CategorieProdottoAction.getListaCategorie())
        },
        inputChangeHandlerCategoria(id, value) {
            return dispatch(CategorieProdottoAction.handleChangeCategoria(id, value))
        },
        salvaCategoria(idFamigliaProdotto) {
            return dispatch(CategorieProdottoAction.salvaCategoria(idFamigliaProdotto))
        },
        deleteCategoriaProdotto(id) {
            return dispatch(CategorieProdottoAction.deleteCategoria(id))
        },
        getCategoriaProdottoDetails(id) {
            return dispatch(CategorieProdottoAction.getCategoriaDetails(id));
        },
        inizializzaNuovaCategoria() {
            return dispatch(CategorieProdottoAction.inizializzaNuovaCategoria())
        }

    }
};

function mapStateToProps(state) {
    return {
        rows: state.prodotto.listProdotto,
        psp: state.prodotto.psp,
        listMC: state.microCategorie.listMC,
        famiglieProdotto: state.famiglieProdotto.listFamiglieProdotto,
        famigliaProdotto: state.famiglieProdotto.famigliaProdotto,
        categoriaProdotto: state.categorieProdotto.categoriaProdotto,
        categorieProdotto: state.categorieProdotto.listCategorieProdotto
    };
};


export default connect(mapStateToProps, mapDispatchToProps)(FamiglieProdotto);
